import { lazy } from 'react';
const PublicInvitationRoutes = [
    {
        label: '',
        key: 'businessPublic',
        path: '/',
        redirect: '/home',
        element: lazy(() => import('@/components/Layout/PublicInvitationLayout')),
        children: [
            {
                key: 'businessPublic-detail', // 业务详情页
                path: 'businessPublic-detail',
                show: true,
                isHeaderImage: false, // 是否需要头图
                element: lazy(() => import('@/page/PublicInvitationDatail'))
            },
            {
                key: 'businessPublic-learCard', // 业务详情页学习卡
                path: 'businessPublic-learCard',
                show: true,
                isHeaderImage: false, // 是否需要头图
                element: lazy(() => import('@/page/PublicInvitationLearCard'))
            }
        ]
    }
];
export default PublicInvitationRoutes;
